module.exports = __webpack_public_path__ + "media/images/common/credit_cards/amex-355c196823cff5cabd01267c5a668775.svg";